/**
 * Browser compatibility check
 *
 * Runs synchronously in <head> before the page body renders so no flash of
 * unsupported content is visible. Uses feature detection (not user-agent
 * parsing) so full-page caches never affect the result — each browser
 * evaluates its own capabilities client-sheadide.
 *
 * When an outdated browser is detected the class 'browser-outdated' is added
 * to <html>. Critical CSS rules in header.php react to that class:
 *  - The normal page content is hidden.
 *  - The #browser-outdated-overlay is shown.
 *
 * Uses ES5 syntax for maximum compatibility.
 */
(function() {
    'use strict';

    /**
     * Feature-detect the CSS and JS capabilities required by Tailwind v4.
     */
    var isModernBrowser = (
        typeof CSS !== 'undefined' &&
        CSS.supports &&
        CSS.supports('container-type', 'inline-size') &&
        'Promise' in window &&
        'fetch' in window
    );

    if (!isModernBrowser) {
        // Adding the class synchronously here (before <body> renders) ensures
        // that the browser-outdated overlay is displayed without any FOUC.
        document.documentElement.className += ' browser-outdated';
    }
})();